import React, { useEffect, useState } from 'react';
import ReactApexChart from "react-apexcharts";
import { getRangos } from '../../../domain/api/UsersApi';
const calcularTamañoHollow = (DataRangos, genero, Igc) => {
    const generoKey = genero === 'M' ? 'hombre' : 'mujer';

    for (const rango of DataRangos) {
        const parametros = JSON.parse(rango.parametros);

        // Verifica si el rango es para el género actual
        if (parametros && parametros[generoKey]) {
            const [min, max] = parametros[generoKey].split('-').map(Number);

            // Comprueba si Igc está dentro del rango
            if (Igc >= min && Igc <= max) {
                const label = rango.valor;
                return {
                    label,
                };
            }
        }
    }

    return {
        label: '',
    };
};
const calcularRangoOptimo = (genero) => {
    if (genero === "F") {
        return [21, 33];
    } else if (genero === "M") {
        return [11, 22];
    }
    return [45, 59]; // Rango predeterminado si no coincide con las condiciones anteriores
};


export default function ChartGrasa({ data, genero }) {

    const [DataRangos, setDataRangos] = useState("")

    useEffect(async () => {
        const rangos = await getRangos('pgc')
        setDataRangos(rangos.respuesta)

    }, [])

    const [rangoY, rangoY2] = calcularRangoOptimo(genero);
    // Extrae los valores de IGC y las fechas correspondientes desde los datos
    const igcValues = data.map((record) => record.igc);

    // Meses correspondientes a los puntos en el eje X
    const months = data.map((record) => {
        const date = new Date(record.datecreate);
        const day = date.getDate();
        const monthNames = [
            "ene", "feb", "mar", "abr", "may", "jun",
            "jul", "ago", "sep", "oct", "nov", "dic"
        ];
        const month = monthNames[date.getMonth()];
        return `${day} ${month}`;
    });

    // Configuración de la gráfica
    const options = {
        chart: {
            id: "line-chart",
            width: "80%",
        },
        xaxis: {
            categories: months,
        },
        yaxis: {
            min: 0,
            max: 60,
            tickAmount: 4,
            labels: {
                colors: ["#005aa9"],
                formatter: function (value) {
                    return Math.round(value);
                },
            },
        },
        fill: {
            type: "gradient",
            gradient: {
                type: "vertical",
                shadeIntensity: 0.2,
                opacityFrom: 0.7,
                opacityTo: 0.7,
                stops: [0, 100],
            },
        },
        stroke: {
            width: 3,
            colors: ["#005aa9"], // Color de la línea aquí
            opacity: 3,
        },
        markers: {
            size: 4,
            colors: '#005aa9', // Color de los puntos (en este caso, el color de peso)
        },
        annotations: {
            yaxis: [
                {
                    y: rangoY,
                    y2: rangoY2,
                    fillColor: "#005aa9", // Color del sombreado del rango óptimo
                    opacity: 0.2,
                },
            ],
        },
        tooltip: {
            custom: function ({ series, seriesIndex, dataPointIndex, w }) {
                const month = months[dataPointIndex]; // Mes correspondiente al punto
                const igcValue = series[0][dataPointIndex]; // Valor de IGC


                const { label } = calcularTamañoHollow(DataRangos, genero, igcValue);

                return (
                    '<div className="custom-tooltip" style="height:50px; width:120px;font-size:12px;border-radius:10%;">' +
                    '<div className="tooltip-title" style="background-color: ' +
                    w.globals.stroke.colors[seriesIndex] +
                    '; color: white; padding-left: 10px; opacity:1">' +
                    month + // Mes en el título
                    '</div>' +
                    '<div className="tooltip-content" style="height: 60px;padding-top: 5px; ">' +
                    '<div className="sales-circle" style="background-color: ' +
                    w.globals.stroke.colors[seriesIndex] +
                    '; border-radius: 50%; width: 10px; height: 10px; display: inline-block; margin-right: 5px;margin-left: 10px; "></div>' +
                    '<span className="sales-text" style="font-weight: bold; margin: 0;">' + Math.floor(igcValue * 10) / 10 + ": " + label +
                    '</span>' +
                    '</div>' +
                    '</div>'
                );
            },
        },
    };


    return (
        <div>
            <div>
                <ReactApexChart options={options} series={[{ name: "IGC", data: igcValues }]} type="line" height={350} id="mi-grafico" />
            </div>
            <div style={{ display: "flex", justifyContent: "center", marginTop: "-5%", marginLeft: "-30%", marginBottom: "6%" }}>
                <div style={{ marginRight: "20px" }}>
                    <div style={{ display: "flex", alignItems: "center" }}>
                        <div
                            style={{
                                width: "10px",
                                height: "3px",
                                backgroundColor: "#005aa9",
                                marginRight: "5px",
                            }}
                        ></div>
                        IGC
                    </div>
                </div>
                <div>
                    <div style={{ display: "flex", alignItems: "center" }}>
                        <div
                            style={{
                                width: "10px",
                                height: "10px",
                                backgroundColor: "#005aa9",
                                opacity: 0.2,
                                marginRight: "5px",
                            }}
                        ></div>
                        Rango Óptimo
                    </div>
                </div>
            </div>
        </div>
    );
};
